import { render, staticRenderFns } from "./Deplist.vue?vue&type=template&id=0e4e6564&scoped=true&"
import script from "./Deplist.vue?vue&type=script&lang=js&"
export * from "./Deplist.vue?vue&type=script&lang=js&"
import style0 from "./Deplist.vue?vue&type=style&index=0&id=0e4e6564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e6564",
  null
  
)

export default component.exports